export const pedagogico = [
  {
    id: "eliminar-disciplina",
    label: "Eliminar Disciplina",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "arquivo_historico", label: "Anexo do histórico", helpText: "Anexe seu histórico acadêmico.", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "arquivo_opcional1", label: "Anexo (opcional)", helpText: "Aqui é um espaço para adicionar outro arquivo, caso você queira enviar junto com a solicitação.", component: "InputArquivo", type: "file", defaultValue: [], required: "opcional" },
        { id: "arquivo_opcional2", label: "Anexo (opcional)", helpText: "Aqui é um espaço para adicionar outro arquivo, caso você queira enviar junto com a solicitação.", component: "InputArquivo", type: "file", defaultValue: [], required: "opcional" },
        { id: "observacao", label: "Detalhe a solicitação", helpText: "Se tiver alguma observação para incluir na solicitação, informe aqui.", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "duvidas-prazos-datas",
    label: "Dúvidas sobre Prazos e Datas",
    prazo: "24hrs",
    prazo_minutos: 1440,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "duvida", label: "Descreva sua dúvida", helpText: "", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "estagio",
    label: "Estágio",
    prazo: "24hrs",
    prazo_minutos: 1440,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "solicitacao", label: "Descreva sua solicitação", helpText: "", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "documentos-estagio",
    label: "Documentos Estágio",
    prazo: "48hrs",
    prazo_minutos: 48 * 60,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "arquivo_rg_frente", label: "Arquivo RG (Frente)", helpText: "Envie apenas a frente do RG.", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "arquivo_rg_verso", label: "Arquivo RG (Verso)", helpText: "Envie apenas o verso do RG.", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "arquivo_cartao_sus_frente", label: "Arquivo Cartão do Sus (Frente)", helpText: "Envie apenas a frente do Cartão.", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "arquivo_cartao_sus_verso", label: "Arquivo Cartão do Sus (Verso)", helpText: "Envie apenas o verso do Cartão.", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "arquivo_apolice_seguro", label: "Apólice de seguro de vida", helpText: "", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "arquivo_cartao_vacina", label: "Cartão de vacina", helpText: "", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "entrega-atestado",
    label: "Entrega de Atestado",
    prazo: "24hrs",
    prazo_minutos: 1440,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "arquivo_atestado", label: "Anexo do atestado", helpText: "Anexe o atestado médico.", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "notas",
    label: "Notas",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "solicitacao", label: "Detalhe a solicitação", helpText: "Descreva qual informação sobre notas deseja.", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "sistema-interativo",
    label: "Ajuda Sistema Interativo",
    prazo: "48hrs",
    prazo_minutos: 2880,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "dificuldade", label: "Descreva a dificuldade", helpText: "", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "arquivo_error", label: "Anexo de erro", helpText: "Caso necessário, anexe uma captura de tela.", component: "InputArquivo", type: "file", defaultValue: [] },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "recuperacao-segunda-chamada",
    label: "Recuperação / 2ª Chamada",
    prazo: "48hrs",
    prazo_minutos: 2880,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "solicitacao", label: "Detalhe a solicitação", helpText: "Explique se precisa de recuperação ou segunda chamada.", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },
  {
    id: "colacao-de-grau", label: "Colação de Grau", prazo: '3 dias', prazo_minutos: 4320, view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "text", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações de resposta por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ]
    }
  },
  {
    id: "repetir-disciplina", label: "Repetir Disciplina", prazo: '24hrs', prazo_minutos: 1440, view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "text", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações de resposta por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "disciplina", label: "Descreva a disciplina", helpText: "", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ]
    }
  },
  {
    id: "troca-de-turma",
    label: "Troca de Turma",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "tel", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "turno_desejado", label: "Turno desejado", helpText: "Informe para qual turno deseja mudar.", component: "InputText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ],
    },
  },

  {
    id: "declaracao-de-vacinacao",
    label: "Declaração de Vacinação",
    prazo: "24hrs",
    prazo_minutos: 1440,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "Informe o curso para a declaração de matrícula.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },

  {
    id: "atestado-de-frequencia",
    label: "Atestado de Frequência",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "Informe o curso para o atestado.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },

  {
    id: "outros-assuntos", label: "Outros Assuntos", prazo: '48hrs', prazo_minutos: 2880, view: {
      type: "form",
      options: [
        { id: "nome_completo", label: "Nome completo", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "cpf", label: "CPF", helpText: "", component: "InputCPF", type: "text", defaultValue: "" },
        { id: "email", label: "Email", helpText: "Você receberá todas as notificações de resposta por e-mail.", component: "InputText", type: "email", defaultValue: "" },
        { id: "curso", label: "Curso", helpText: "", component: "InputText", type: "text", defaultValue: "" },
        { id: "assunto", label: "Descreva o assunto", helpText: "", component: "InputMultText", type: "text", defaultValue: "" },
        { id: "", label: "Enviar", helpText: "", type: "button-submit", component: "ButtonSubmit" }
      ]
    }
  },

  {
    id: "solicitacao-de-boletim",
    label: "Solicitação de Boletim",
    prazo: "72hrs",
    prazo_minutos: 4320,
    view: {
      type: "form",
      options: [
        {
          id: "nome_completo",
          label: "Nome completo",
          helpText: "",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
        },
        {
          id: "email",
          label: "Email",
          helpText:
            "Você receberá todas as notificações de resposta por e-mail.",
          component: "InputText",
          type: "email",
          defaultValue: "",
        },
        {
          id: "curso",
          label: "Curso",
          helpText: "Informe o curso do boletim.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "periodo",
          label: "Período",
          helpText: "Informe o período ou semestre do boletim desejado.",
          component: "InputText",
          type: "text",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ],
    },
  },
]